// extracted by mini-css-extract-plugin
export var copyableField = "_rj-4";
export var customerBadge = "_rj-0";
export var customerInfoTitle = "_rj-2";
export var details = "_rj-1";
export var dropdownContainer = "_rj-5";
export var dropdownImage = "_rj-6";
export var editAssigneeForm = "_rj-a";
export var editButton = "_rj-3";
export var email = "_rj-7";
export var hidden = "_rj-d";
export var input = "_rj-8";
export var saveButton = "_rj-b";
export var shopifyIcon = "_rj-c";
export var suggestionBadge = "_rj-e";
export var suggestionText = "_rj-f";
export var username = "_rj-9";